import React from "react";
import { isSet } from "../../../../../../utils/commonUtils";
import FormInputs from "../../../../../../components/UI/FormInputs";

const NewYesNo = ({ 
    showNotes, 
    notes, 
    options, 
    col, 
    failedValue, 
    list, 
    label, 
    appendClass, 
    readOnly, 
    validation, 
    ...props 
}) => {
    
    // Determine main column width based on if side-notes are present
    const mainColClass = isSet(notes) && notes.length > 0 ? (isSet(col) ? col : 'col-8') : 'col-12';

    return (
        <div className="row">
            {/* 1. Side Notes Section (Preserved from original logic) */}
            {isSet(notes) && notes.length > 0 ? (
                <div className="col-4">
                    <strong>{label}</strong>
                    <ul style={{ marginLeft: '30px' }}>
                        {notes.map((itm, itmIndex) => (
                            <li key={itmIndex}>{itm}</li>
                        ))}
                    </ul>
                </div>
            ) : null}

            {/* 2. Main Form Area */}
            <div className={`${mainColClass} px-0`}>
                <div className={`card-body p-2 ${appendClass}`}>
                    {/* Loop through the Questions List */}
                    {list.map((tData, tIndex) => {
                        return (
                            <div className="mb-2 pb-2" key={tIndex}>
                                <div className="form-group row mb-0 align-items-center">
                                    
                                    {/* Question Label Column (Col-9) */}
                                    <div className="col-md-9">
                                        <label className="form-label mb-0">
                                            {/* Handle Subfields indenting */}
                                            {isSet(tData.isSubField, false) === true ? (
                                                <span style={{ paddingLeft: '20px' }}>{tData.label}</span>
                                            ) : (
                                                tData.label
                                            )}
                                        </label>
                                        
                                        {/* Validation Message */}
                                        {isSet(validation) && isSet(validation[tData.name], "") !== "" && (
                                            <div className="text-danger small mt-1">
                                                {validation[tData.name]}
                                            </div>
                                        )}
                                    </div>

                                    {/* Radio Buttons Column (Col-3) */}
                                    <div className="mt-2 mt-md-0 col-md-3 d-flex justify-content-end align-items-center">
                                        {isSet(tData.name, '') !== '' && options.map((option, optionIndex) => {
                                            
                                            // Logic to check if this option is selected
                                            const isChecked = isSet(props.formData[tData.name], null) === option.value;

                                            // Logic for Red styling on "Failed" values (e.g. if Yes is selected and Yes is a failed value)
                                            const activeFailedValue = isSet(tData.failedValue) ? tData.failedValue : failedValue;
                                            let inputStyle = {};
                                            
                                            if (
                                                isChecked && 
                                                isSet(activeFailedValue, null) !== null && 
                                                activeFailedValue.indexOf(option.value) >= 0
                                            ) {
                                                inputStyle = { backgroundColor: 'red', borderColor: 'red' };
                                            }

                                            return (
                                                <div className="form-check form-check-inline" key={optionIndex}>
                                                    <input 
                                                        className="form-check-input" 
                                                        type="radio" 
                                                        name={`${tData.name}_${tIndex}`} // Unique group name per question
                                                        id={`${tData.name}_${option.value}_${tIndex}`} 
                                                        value={option.value}
                                                        checked={isChecked}
                                                        disabled={readOnly}
                                                        style={inputStyle}
                                                        onChange={() => props.changeHandler(tData.name, option.value)}
                                                    />
                                                    <label 
                                                        className="form-check-label" 
                                                        htmlFor={`${tData.name}_${option.value}_${tIndex}`}
                                                    >
                                                        {option.label}
                                                    </label>
                                                </div>
                                            );
                                        })}
                                    </div>
                                </div>

                                {/* Optional: Per-row Notes (Text Area) if enabled */}
                                {showNotes && (
                                    <div className="row mt-2">
                                        <div className="col-12">
                                            <FormInputs
                                                type="TextArea"
                                                name={tData.notesName || `${tData.name}_notes`}
                                                id={tData.notesName || `${tData.name}_notes`}
                                                value={props.formData[tData.notesName || `${tData.name}_notes`] || ""}
                                                changeHandler={(value) => props.changeHandler(tData.notesName || `${tData.name}_notes`, value)}
                                                readOnly={readOnly}
                                                placeholder={`${tData.label} notes`}
                                                className="form-control form-control-sm"
                                            />
                                        </div>
                                    </div>
                                )}
                            </div>
                        );
                    })}
                </div>
            </div>
        </div>
    );
};

NewYesNo.defaultProps = {
    appendClass: '',
    failedValue: null,
    validation: {},
    showNotes: false,
    col: 'col-12'
};

export default NewYesNo;